import type { UiStrings } from "../types";

export const id: UiStrings = {
  nav: {
    category: "Kategori",
    forYourWork: "Untuk Pekerjaan Anda",
    searchPlaceholder: "Cari lebih dari 300 alat...",
    heroPlaceholder: "Apa yang Anda butuhkan?",
  },
  trustBadges: {
    noLogin: "Tanpa login untuk memakai alat",
    freeUsesDaily: "10 kali penggunaan percobaan per hari",
    filesNeverStored: "File Anda tidak pernah disimpan",
    worksAnyDevice: "Berfungsi di perangkat apa pun",
    worksWhenAiBlocked: "Tetap berfungsi meski kebijakan AI perusahaan Anda membatasi",
    availableInLanguages: "Tersedia dalam berbagai bahasa",
  },
  common: {
    backToHome: "Kembali ke Beranda",
    home: "Beranda",
    signIn: "Masuk",
    account: "Akun",
    contact: "Kontak",
    blog: "Blog",
    shareThisTool: "Bagikan alat ini",
    download: "Unduh",
    copy: "Salin",
    copied: "Tersalin",
  },
  footer: {
    tagline: "Platform produktivitas online serba ada. Lebih dari 300 alat profesional, aplikasi premium, dan produk alur kerja untuk kebutuhan sehari-hari.",
    company: "Perusahaan",
    about: "Tentang Kami",
    blog: "Blog",
    contact: "Kontak",
    pricing: "Harga",
    privacyPolicy: "Kebijakan Privasi",
    termsOfService: "Ketentuan Layanan",
    allTools: "Semua Alat",
    allRightsReserved: "Hak cipta dilindungi.",
  },
  contact: {
    title: "Hubungi Kami",
    subtitle: "Ada pertanyaan, masukan, atau sesuatu yang tidak berfungsi dengan baik? Kami siap membantu.",
    email: "Email",
    responseTime: "Waktu Respons",
    responseTimeValue: "Kami biasanya merespons dalam 1-2 hari kerja.",
    sendEmail: "Kirim email ke kami",
    billingNote: "Untuk pertanyaan seputar tagihan, sertakan alamat email yang terhubung dengan akun Anda.",
    whoWeAreTitle: "Siapa yang mengoperasikan FreeDailyPro",
    whoWeAreBody: "FreeDailyPro dioperasikan oleh DreamUSA LLC, bisnis perangkat lunak kecil yang dikelola secara independen. Tidak ada tim dukungan besar di baliknya -- orang yang membaca dan membalas email Anda juga adalah orang yang membangun dan memelihara alat-alatnya, itulah sebabnya balasan terkadang memerlukan waktu satu atau dua hari, bukan instan.",
    whatWeSupportTitle: "Apa yang bisa kami bantu",
    whatWeSupportBody: "Laporan bug untuk salah satu dari 300+ alat, permintaan fitur, pertanyaan penagihan dan langganan (termasuk pembatalan dan permintaan pengembalian dana), masalah akun dan login, serta umpan balik umum tentang apa yang berjalan baik atau tidak. Jika sebuah alat menghasilkan hasil yang salah, menyertakan jenis file dan kira-kira apa yang salah membantu memperbaikinya lebih cepat.",
  },
  home: {
    heroTitleLine1: "Setiap tugas profesional.",
    heroTitleLine2: "Satu platform di browser",
    heroSubtitle: "Gunakan satu alat. Jalankan alur kerja. Bangun dengan API & MCP. Atau minta kami membuatkannya untuk Anda.",
    localSignalUsedTitle: "Digunakan di perangkat ini",
    localSignalTryTitle: "Coba salah satu ini",
    localSignalBadge: "Lokal \u00b7 Tanpa jaringan",
    localSignalUsedDesc: "alat digunakan di perangkat ini \u2014 tidak ada yang meninggalkan browser Anda",
    localSignalTryDesc: "alat belum digunakan di perangkat ini \u2014 semuanya berjalan langsung di browser Anda",
    corporateSafeTitle: "Aman untuk Perusahaan",
    corporateSafeSubtitle: "Apa pun kebijakan AI perusahaan Anda, FreeDailyPro tetap berfungsi sama",
    corporateSafeBlockedTitle: "Diblokir Sepenuhnya",
    corporateSafeBlockedDesc: "Tidak ada jenis alat AI apa pun yang diizinkan di jaringan. Semua alat FreeDailyPro tetap berfungsi \u2014 tidak ada yang pernah diunggah ke server.",
    corporateSafeGovernedTitle: "Akses Terkontrol",
    corporateSafeGovernedDesc: "AI hanya diizinkan melalui alat yang disetujui dan diverifikasi. Tidak ada yang perlu disetujui di sini \u2014 tidak ada panggilan ke server eksternal yang perlu diperiksa.",
    corporateSafeOpenTitle: "Tanpa Batasan",
    corporateSafeOpenDesc: "Gunakan apa pun yang menyelesaikan pekerjaan. FreeDailyPro lebih cepat karena tidak ada yang perlu diunggah atau ditunggu.",
    corporateSafeCta: "Lihat rincian lengkap keamanan perusahaan \u2192",
    exploreToolkitTitle: "Jelajahi kumpulan alat",
    exploreToolkitSubtitle: "300+ alat dalam {catCount} kategori \u2014 pilih salah satu, atau cari saja.",
    forYourWorkTitle: "Dibuat sesuai cara kerja Anda yang sebenarnya",
    forYourWorkSubtitle: "Alat profesional yang sama, diatur berdasarkan pekerjaan Anda yang sebenarnya",
    exploreTools: "Jelajahi alat",
    seeAllRoles: "Lihat semua {count} peran \u2192",
    blogTitle: "Dari Blog",
    viewAllPosts: "Lihat Semua Artikel",
    faqTitle: "Ada pertanyaan? Lihat FAQ kami",
    faqMoreLink: "Mencari jawaban lain? Jelajahi FAQ lengkap \u2192",
    toolkitProseTitle: "Kumpulan alat profesional yang dibuat untuk pekerjaan sehari-hari, bukan hanya tugas sesekali",
    closingCtaTitle: "Jangan lupa tambahkan pintasan",
    closingCtaDesc: "Tambahkan sekali dan selalu siap sekali klik \u2014 instal pintasan desktop atau tambahkan ke layar utama ponsel Anda, dan FreeDailyPro akan terbuka seperti aplikasi asli, tanpa perlu mencari tab browser.",
    categoriesLabel: "{count} KATEGORI \u2192",
    viewAllCategoriesLabel: "LIHAT SEMUA {count} KATEGORI \u2192",
    yourFavorites: "Favorit Anda",
    recentlyUsed: "Baru Digunakan",
    toolkitProsePara1: "FreeDailyPro menggabungkan 300+ alat sehari-hari \u2014 pengeditan PDF, konversi gambar, pemotongan video, pembersihan audio, pemformatan teks, dan puluhan kalkulator \u2014 dalam satu tempat, jadi Anda tidak perlu berpindah-pindah situs untuk setiap tugas. Sebagian besar alat tidak memerlukan pendaftaran, dan alat berbasis file mencakup 10 kali penggunaan gratis setiap hari.",
    toolkitProsePara2: "Setiap alat berjalan sepenuhnya di browser Anda. Saat Anda mengompres PDF atau menghapus latar belakang foto, file tersebut tidak pernah meninggalkan perangkat Anda \u2014 tidak diunggah, diproses di server, atau disimpan di mana pun, bahkan sementara. Itu bukan keterbatasan, itu memang seluruh desainnya: hasil lebih cepat, dan tidak perlu khawatir meskipun filenya sensitif.",
    toolkitProsePara3: "Pendekatan lokal ini juga berarti FreeDailyPro bekerja sama saja baik di laptop pribadi, komputer kerja yang dibatasi, atau jaringan dengan kebijakan penggunaan AI yang ketat \u2014 tidak ada panggilan ke server eksternal yang perlu dievaluasi tim IT, karena memang tidak ada.",
    toolkitProsePara4: "Baik Anda perlu menggabungkan PDF untuk laporan, mengubah ukuran gambar untuk listing, memotong klip video untuk media sosial, atau menghitung KPR atau pajak dengan cepat, FreeDailyPro dibuat menjadi alat yang Anda gunakan setiap hari \u2014 bukan hanya yang Anda ingat saat kebetulan membutuhkannya.",
    heroLaneToolsTitle: "Alat profesional untuk tugas individual",
    heroLaneToolsDesc: "PDF, gambar, video & lainnya -- satu tindakan, selesai di browser Anda.",
    heroLaneToolsCta: "Jelajahi alat",
    heroLanePremiumTitle: "Aplikasi premium untuk pekerjaan besar",
    heroLanePremiumDesc: "Aplikasi multi-langkah: dokumen, formulir, perencana, cetak, dan acara.",
    heroLanePremiumCta: "Lihat aplikasi",
    heroLaneWorkflowTitle: "Produk alur kerja",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite & lainnya -- beberapa langkah, satu hasil.",
    heroLaneWorkflowCta: "Lihat produk alur kerja",
    heroLaneApiTitle: "API & MCP",
    heroLaneApiDesc: "Panggil alat yang sama dari kode Anda sendiri atau agen AI.",
    heroLaneApiCta: "Buka halaman developer",
    heroLaneCustomTitle: "Perangkat lunak kustom",
    heroLaneCustomDesc: "Ceritakan kebutuhan Anda. Kami membuatnya dengan biaya sekali bayar, lalu Anda membayar biaya penggunaan bulanan yang kecil.",
    heroLaneCustomCta: "Minta pembuatan",
  },
  install: {
    desktopTitle: "Pintasan Desktop",
    desktopSubtitle: "Sekali klik, langsung terbuka",
    mobileTitle: "Aplikasi Seluler",
    mobileSubtitle: "Tambahkan ke layar utama Anda",
    addToHomeScreenTitle: "Tambahkan FreeDailyPro ke Layar Utama Anda",
    iosInstructions: "Ketuk ikon Bagikan di Safari, lalu pilih \"Tambah ke Layar Utama.\"",
    genericInstructions: "Buka menu browser Anda dan cari \"Tambah ke layar utama\" atau \"Instal aplikasi.\"",
    desktopUnavailableTitle: "Instalasi sekali klik tidak tersedia di browser ini",
    desktopUnavailableDesc: "Anda tetap bisa menandai halaman ini, atau menyeret ikon bilah alamat ke desktop Anda.",
    desktopSuccess: "Pintasan berhasil dibuat! Cari ikon FreeDailyPro.",
    mobileSuccess: "Berhasil ditambahkan! Cari ikon FreeDailyPro di layar utama Anda.",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "{count} penggunaan percobaan tersisa hari ini",
    whatThisToolDoes: "Apa yang dilakukan alat ini",
    proTips: "Tips Pro",
    continueWith: "Lanjutkan dengan",
    moreFromCategory: "Lainnya dari kategori ini",
  },
  usageStrip: {
    freeUsesPerDay: "Uji coba: {limit} penggunaan/hari",
    remainingToday: "{count} tersisa hari ini",
    dayPassLabel: "Penggunaan tanpa batas tanpa iklan, day pass $1",
    monthlyLabel: "Penggunaan tanpa batas tanpa iklan, paket bulanan $4.99",
    quickBuy: "Beli Cepat",
  },
  platformsBanner: {
    title: "Di mana API ini sebenarnya tersedia",
    subtitle: "Bukan halaman yang bertuliskan \"segera hadir\" -- ini adalah listing nyata dan berfungsi yang bisa Anda langganan atau sambungkan hari ini.",
    postmanDetail: "Permintaan siap pakai, terdokumentasi lengkap",
    rapidApiDetail: "Berlangganan dengan penagihan berbasis penggunaan melalui marketplace Rapid",
    mcpRegistryDetail: "Terdaftar resmi sebagai com.freedailypro/tools, {mcp} tools, satu endpoint",
  },
  pricingBanner: {
    title: "Harga Transparan",
    subtitle: "Tidak ada tingkatan tersembunyi, tidak ada batas mengejutkan -- persis apa yang dibayar dan apa yang didapat di setiap paket.",
    toolPricingTitle: "Harga tools berbasis penggunaan",
    apiPricingTitle: "Harga API & MCP berbasis penggunaan",
    freeLabel: "Percobaan",
    freeToolDetail: "10 penggunaan/hari untuk Professional Tools, 2 untuk Premium Applications",
    dayPassDetail: "$1/hari -- tanpa iklan, penggunaan tanpa batas",
    monthlyDetail: "$4.99/bulan -- tanpa iklan, penggunaan tanpa batas",
    monthlySavingsNote: "Lebih murah dari 5 Day Pass sebulan",
    freeApiDetail: "20.000 panggilan/bulan",
    premiumDetail: "$24/bulan -- 200.000 panggilan",
    ultraDetail: "$69/bulan -- 750.000 panggilan",
    megaDetail: "$129/bulan -- 2.000.000 panggilan + prioritas",
  },
  apiMcpBanner: {
    title: "Kini dengan API & MCP",
    description: "Panggil 200+ tools kami langsung dari kode Anda sendiri, atau hubungkan agen AI melalui MCP -- tools yang sama, di sisi server, untuk saat browser saja tidak cukup.",
    oneKey: "Satu kunci untuk semuanya",
    restApiMcp: "REST API + MCP",
    anyLanguage: "Bahasa apa pun, server apa pun",
    cta: "Jelajahi API & MCP",
  },
  premiumApps: {
    title: "Aplikasi Premium",
    subtitle: "Aplikasi multi-langkah yang sesungguhnya, bukan sekadar tools satu aksi -- juga bisa diinstal secara mandiri.",
    seeAll: "Lihat semua aplikasi Premium",
  },
  googleDrive: {
    openFromGoogle: "Buka dari Google Drive",
    saveToGoogle: "Simpan ke Google Drive",
    signingIn: "Membuka masuk Google...",
    fetching: "Mengambil file Anda dari Google Drive...",
    saving: "Menyimpan ke Google Drive...",
    saved: "Tersimpan di Google Drive",
    viewInDrive: "Lihat di Drive",
    popupBlocked: "Browser Anda memblokir jendela masuk Google. Izinkan pop-up untuk situs ini, lalu coba lagi.",
    cancelled: "Masuk Google ditutup sebelum selesai. Tidak ada yang dibuka atau disimpan.",
    denied: "Akses Google Drive tidak diizinkan, jadi tidak ada yang dibuka atau disimpan. Coba lagi dan izinkan akses ke file yang Anda pilih.",
    loadFailed: "Tidak dapat terhubung ke Google. Periksa koneksi atau pemblokir konten Anda, lalu coba lagi.",
    network: "Koneksi ke Google Drive terputus. Silakan coba lagi.",
    tooLarge: "File itu terlalu besar untuk dibuka di browser.",
    api: "Google Drive tidak dapat menyelesaikannya. Silakan coba lagi.",
    largeFile: "File ini lebih dari 50 MB. Mungkin lebih lama atau kehabisan memori browser.",
    privacyNote: "File Anda berpindah antara browser Anda dan Google. File tidak dikirim ke server kami.",
  },
};
